import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Typography, Avatar } from 'antd';
import { FormattedMessage } from 'react-intl';
//UTILITY
import {
  getImgBig,
  getTitle,
  getDescription,
  getInfo,
  isEmptyObject,
} from '../../../Utility/utility';
//IMAGE
import close from 'static/img/remove_newdesign.png';

import parse from 'html-react-parser';
import CloseButton from '../../../Utility/closeButton';

import './BikeClubMainPreview.css';

import { history } from '../../../../store';
import { BikerBedIcon, BikerClubIcon } from '../../MainMenu/svg';
import { pageScope } from '../../../../constants/mapConstants';
import ActionState from './actionState';
import { getRequestInfo } from '../components/BikeClubRequest';
import { getRequestInfo as bikerBedGetRequestInfo } from '../../BikerBed/components/BikerBedRequest';
import { useSelector } from 'react-redux';
const { Paragraph } = Typography;

import { getUserLink, decodeSpecLetters } from '../../../Utility/utility';

import { useLocation } from 'react-router-dom';
import PreviewBigImage from '../../TourPreview/PreviewBigImage';
import PreviewBodyWrapper from '../../TourPreview/PreviewBodyWrapper';

const previewListStyle = {
  position: 'relative',
  bottom: 0,
  height: 200,
};

const previewViewStyle = {
  marginRight: '350px',
};

const previewListContainerStyle = {
  height: '100%',
  marginRight: 0,
};

const styleAvatar = {
  width: '100%',
  height: '100%',
  lineHeight: '46px',
  fontSize: 26,
};

const BikeClubMainPreview = (props) => {
  const measure = getInfo(props.previewJson);
  const getImgB = getImgBig(props.previewJson);
  const desc = getDescription(props.previewJson);
  const title = getTitle(props.previewJson);

  let { owner = {} } = props.previewJson;
  owner = !owner ? {} : owner;
  const { avatar = {}, name = '', id = 0 } = owner;

  const {
    is_member = 0,
    count_followers = 0,
    count_members = 0,
    count_tours = 0,
  } = props.previewJson;

  const [isMember, setIsMember] = useState(is_member);
  const [countMembers, setCountMembers] = useState(count_members);
  const [countFollowers, setCountFollowers] = useState(count_followers);
  const [status, getStatus] = useState('');
  const { authentication = {} } = useSelector((store) => store);
  const { isLoggedIn, user = {} } = authentication;
  const location = useLocation();

  useEffect(() => {
    setIsMember(is_member);
  }, [is_member]);

  useEffect(() => {
    setCountMembers(count_members);
  }, [count_members]);

  useEffect(() => {
    setCountFollowers(count_followers);
  }, [count_followers]);

  useEffect(() => {
    const id = props.previewJson.id;
    isBikerBed()
      ? bikerBedGetRequestInfo(id, getStatus)
      : getRequestInfo(id, getStatus);
  }, [isMember]);

  const header = (
    <div
      style={{
        position: 'absolute',
        right: -5,
        top: -5,
        cursor: 'pointer',
        width: 20,
        height: 20,
        zIndex: 5,
      }}
      onClick={() => {
        props.closePreviewer({});
      }}
    >
      <CloseButton />
    </div>
  );

  const isBikerBed = () =>
    getScope(props.previewJson.scope, props.scope) === pageScope.bikerbed;

  const getScope = (pointScope, mapScope) => {
    return pointScope ? pointScope : mapScope;
  };

  const renderProps = () => {
    return (
      <div className="info">
        <div>
          <FormattedMessage id="Tours" defaultMessage="Tours" />:
          {`  ${count_tours}`}
        </div>
        <div>
          {isBikerBed() ? (
            <React.Fragment>
              <FormattedMessage id="Followers" defaultMessage="Followers" />:
              {`  ${countFollowers}`}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <FormattedMessage id="Members" defaultMessage="Members" />:
              {`  ${countMembers}`}
            </React.Fragment>
          )}
        </div>
        <div>
          <FormattedMessage id="Country" defaultMessage="Country" />:
          {`  ${props.previewJson.country}`}
        </div>
      </div>
    );
  };

  return Object.keys(props.previewJson).length === 0 ? null : (
    <div
      id="clubPreviewContainer"
      className="clubPreviewContainer"
      style={
        props.previewJson.view
          ? previewViewStyle
          : props.fromList
          ? previewListContainerStyle
          : {}
      }
    >
      <div
        className="clubPreviewLayout"
        style={props.fromList ? previewListStyle : {}}
      >
        {props.fromList ? null : header}
        <div className="bodyClubPreview">
          <PreviewBigImage
            {...props}
            scope={getScope(props.previewJson.scope, props.scope)}
          />

          {/* <div className="content">
            <div className="tourPreviewBodyContentTitle">
                <span>{title}</span>
            </div>
            {(props.fetching === true)? 
                        <Card bordered={false} loading={true} className="descLoad"/>
                        :
                        <div className="tourPreviewBodyContentDescription">
                            <Paragraph ellipsis={{ rows:9 }}>{decodeSpecLetters(desc)}</Paragraph>
                        </div>
                    }
          </div> */}

          <div className="tourPreviewBodyMainWrapper">
            <div
              className="entityPreviewBodyContentTitle"
              style={props.fromList ? { cursor: 'pointer' } : {}}
              onClick={() =>
                props.fromList ? handleClick(props.previewJson, props) : false
              }
            >
              <span>{title}</span>
            </div>
            <PreviewBodyWrapper
              {...props}
              EntityIcon={isBikerBed() ? BikerBedIcon : BikerClubIcon}
              render={renderProps}
            />
            <div className="entity-bottom-buttons-wrapper">
              <ActionState
                isBikerBed={isBikerBed()}
                isMember={isMember}
                setIsMember={setIsMember}
                setCountFollowers={setCountFollowers}
                setCountMembers={setCountMembers}
                countFollowers={countFollowers}
                countMembers={countMembers}
                status={status}
                isLoggedIn={isLoggedIn}
                previewJson={props.previewJson}
                userData={user}
                fetching={props.fetching}
                className="entity-bottom-button"
              />
              <Button
                style={{ minWidth: 160 }}
                type="primary"
                className="viewBtn entity-bottom-button"
                onClick={() =>
                  history.push(
                    `/${getScope(props.previewJson.scope, props.scope)}/${
                      props.urlTitle
                    }_${props.previewJson.id}`,
                    { prevUrl: location.pathname }
                  )
                }
              >
                <span>
                  <FormattedMessage id="View" defaultMessage="View" />
                </span>
              </Button>
            </div>
          </div>
          {/* <div style={{height: 165, position:"relative", borderRight: "1px solid #625f60",width: 1,margin: "0px",margin: "0px 10px"}}></div> */}
          {/* <div className="actionsBtn">
            
          </div> */}
          {/* <div style={{position: 'absolute', right:10, top: 15}}>
                {isBikerBed() ? <BikerBedIcon /> : <BikerClubIcon />}
            </div> */}
        </div>
      </div>
    </div>
  );
};

export default BikeClubMainPreview;
